import {
  AfterViewInit,
  Component,
  ElementRef,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
    selector: 'app-compare-image',
    templateUrl: './compare-image.component.html',
    styleUrls: ['./compare-image.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class CompareImageComponent implements AfterViewInit {
  @ViewChild('container') container!: ElementRef;
  @Input() src1: string = '';
  @Input() src2: string = '';
  @Output() stopCompare: EventEmitter<boolean> = new EventEmitter();
  @Output() downloadRequested: EventEmitter<boolean> = new EventEmitter();

  maxWidth = 0;
  maxHeight = 0;
  showCompare = false;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.maxWidth = this.container.nativeElement.offsetWidth;
      this.maxHeight = this.container.nativeElement.offsetHeight;
      this.showCompare = true;
    });
  }
}
